module.exports = [
    { value: 'musik',     label: 'Musik' },
    { value: 'kultur',     label: 'Kultur' },
    { value: 'journale',     label: 'Journale' },
    { value: 'wissen',     label: 'Wissen' },
    { value: 'gesellschaft',     label: 'Gesellschaft' },
    { value: 'religion',     label: 'Religion' },
];
